// CLIENT-FACING ESTIMATE PDF
// Clean, professional. NO strategy, NO internal notes, NO profitability.
// This is what gets sent to the customer.

export async function generateEstimatePDF(data, bizName, tier) {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });
  const W = 215.9, H = 279.4;
  const rnum = "MR-" + new Date().getFullYear() + "-" + Date.now().toString().slice(-8);
  const tl = tier === "premium" ? "PREMIUM" : "PRO";
  const ss = (data.scopeSlider !== undefined ? data.scopeSlider : 50) / 100;
  const rs = (data.recurringSlider !== undefined ? data.recurringSlider : 50) / 100;
  const sp = data.pricing.hasScopeWork ? Math.round((data.pricing.scopeLow + (data.pricing.scopeHigh - data.pricing.scopeLow) * ss) / 5) * 5 : 0;
  const wp = Math.round((data.pricing.wLow + (data.pricing.wHigh - data.pricing.wLow) * rs) / 5) * 5;
  const bp = Math.round(wp * 1.15 / 5) * 5;

  // Light background
  doc.setFillColor(250, 250, 250); doc.rect(0, 0, W, H, "F");

  // Header bar
  const hh = tier === "premium" ? 28 : tier === "pro" ? 24 : 20;
  doc.setFillColor(232, 85, 61); doc.rect(0, 0, W, tier === "premium" ? 3 : 2, "F");
  doc.setFillColor(245, 242, 239); doc.rect(0, tier === "premium" ? 4 : 2, W, hh, "F");
  if (tier === "pro") { doc.setFillColor(43, 165, 142); doc.rect(0, 2 + hh, W, 0.5, "F"); }

  // Company name + report number
  if (tier === "premium") {
    // Premium: certified layout with MOWRATE platform watermark
    doc.setFont("helvetica", "bold"); doc.setFontSize(8); doc.setTextColor(232, 85, 61);
    doc.text("MOWRATE", 14, 4 + hh * 0.3);
    doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.setTextColor(28, 28, 40);
    doc.text(bizName || "Your Lawn Care Company", 14, 4 + hh * 0.6);
  } else {
    // Pro: contractor's business name only
    doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.setTextColor(28, 28, 40);
    doc.text(bizName || "Your Lawn Care Company", 14, (tier === "pro" ? 2 : 2) + hh * 0.55);
  }
  doc.setFont("courier", "bold"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text(rnum, W - 14, (tier === "premium" ? 4 : 2) + hh * 0.55, { align: "right" });
  doc.setFont("courier", "normal");
  doc.text(new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }), W - 14, (tier === "premium" ? 4 : 2) + hh * 0.8, { align: "right" });

  // Subtitle
  doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text("PROPERTY SERVICE ESTIMATE", 14, (tier === "premium" ? 4 : 2) + hh * 0.8);

  let y = (tier === "premium" ? 4 : 2) + hh + 16;

  // Address
  doc.setFont("helvetica", "bold"); doc.setFontSize(18); doc.setTextColor(28, 28, 40);
  doc.text(data.address.split(",")[0], 14, y); y += 8;
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(107, 114, 128);
  doc.text(data.address.split(",").slice(1).join(",").trim(), 14, y); y += 14;

  // Property stats
  doc.setFillColor(237, 235, 232); doc.roundedRect(14, y, W - 28, 22, 2, 2, "F");
  doc.setFont("courier", "bold"); doc.setFontSize(11); doc.setTextColor(232, 85, 61);
  doc.text(data.grassSqFt.toLocaleString() + " SQ FT TURF", W / 2, y + 10, { align: "center" });
  doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text("LOT: " + data.totalSqFt.toLocaleString() + " SQ FT", W / 2, y + 17, { align: "center" });
  y += 30;

  // This Visit price (if scope work)
  if (data.pricing.hasScopeWork) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(232, 85, 61);
    doc.text("THIS VISIT", 14, y); y += 8;
    doc.setFontSize(28); doc.text("$" + sp, 14, y);
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(107, 114, 128);
    doc.text("One-time service", 70, y); y += 14;
  }

  // Recurring pricing
  doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text(data.pricing.hasScopeWork ? "ONGOING MAINTENANCE" : "RECURRING SERVICE", 14, y); y += 8;
  const hw = (W - 34) / 2;
  // Weekly box
  doc.setFillColor(245, 242, 239); doc.roundedRect(14, y, hw, 22, 1.5, 1.5, "F");
  doc.setFillColor(232, 85, 61); doc.roundedRect(14, y, hw, 1.5, 0, 0, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text("WEEKLY", 18, y + 7); doc.setFontSize(20); doc.setTextColor(232, 85, 61);
  doc.text("$" + wp, 18, y + 18);
  // Biweekly box
  doc.setFillColor(245, 242, 239); doc.roundedRect(14 + hw + 6, y, hw, 22, 1.5, 1.5, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
  doc.text("BIWEEKLY", 18 + hw + 6, y + 7); doc.setFontSize(20); doc.setTextColor(45, 45, 58);
  doc.text("$" + bp, 18 + hw + 6, y + 18);
  y += 30;

  // Services list
  if (data.pricing.breakdown?.length > 0) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(107, 114, 128);
    doc.text("SERVICES INCLUDED", 14, y); y += 6;
    data.pricing.breakdown.forEach(item => {
      if (y > H - 30) {
        doc.addPage(); doc.setFillColor(250, 250, 250); doc.rect(0, 0, W, H, "F"); y = 20;
      }
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(45, 45, 58);
      doc.text("  " + item.label, 14, y);
      doc.setFont("courier", "bold"); doc.setTextColor(232, 85, 61);
      doc.text(item.bidOnly ? "BID" : "$" + item.price, W - 18, y, { align: "right" }); y += 5.5;
    });
  }

  // Footer
  const fY = H - 12;
  doc.setFillColor(232, 85, 61); doc.rect(14, fY - 4, W - 28, 0.4, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(8); doc.setTextColor(45, 45, 58);
  doc.text(bizName || "Your Lawn Care Company", 14, fY);
  doc.setFont("courier", "normal"); doc.setFontSize(6.5); doc.setTextColor(107, 114, 128);
  doc.text("Powered by MowRate", W - 14, fY, { align: "right" });

  return doc;
}

// Keep old name as alias for backwards compat
export const generatePDF = generateEstimatePDF;
